export const rekamMedis =
{
  path: '/family-members',
  name: 'familyMembers',
  hidden: false,
  component: () => import('@/components/family_members/index'),
  meta: {
    title: 'Anggota Keluarga',
    icon: 'fa-user',
    roles: ['pasien']
  },
  children: [{
    path: 'data_family',
    name: 'DataFamily',
    hidden: true,
    meta: {
      title: 'Daftar Anggota Keluarga',
      icon: 'fa-area-chart',
      roles: ['pasien']
    },
    component: () => import('@/components/family_members/components/masterData')
  },
  {
    path: 'form_family',
    name: 'formFamily',
    hidden: true,
    meta: {
      title: 'Tambah Anggota Keluarga',
      icon: 'fa-area-chart',
      roles: ['pasien']
    },
    component: () => import('@/components/family_members/components/formFamily')
  },
  ]
}
export default rekamMedis



// WEBPACK FOOTER //
// ./src/router/modules/family-members.js